import { Component, EnvironmentInjector, Inject } from "@angular/core";
//import { AppInjector } from './app.module';
import * as moment from "moment";
import { PerformanceMetricsService } from "./services/performance-metrics.service";


@Component({
  standalone: false,
  selector: 'mysynch-app',
  //templateUrl: '../app/app.view.html'
  template:`<ng1-app></ng1-app>`
})
export class AppComponent {
    moment:any = moment;
    
     constructor(@Inject('MySynchFactory') private MSF:any,
                 @Inject(PerformanceMetricsService) private perfMetricsSvc:any) {
    }
    
    ngOnInit() {
        // Initialize performance metrics
        this.perfMetricsSvc.init();   
    }
}